import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IUserTasksService } from "services/UserTasksService";
import { UserTaskModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  UserTask: new UserTaskModel(),
  LoadingTask: false,
};

export const taskActionsSlice = createSlice({
  name: "taskActions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserTask.pending, (state) => {
        state.LoadingTask = true;
      })
      .addCase(getUserTask.rejected, (state) => {
        state.LoadingTask = false;
      })
      .addCase(getUserTask.fulfilled, (state, action) => {
        state.LoadingTask = false;
        state.UserTask = action.payload;
      })
      .addCase(resumeTask.pending, (state) => {
        state.LoadingTask = true;
      })
      .addCase(holdTask.pending, (state) => {
        state.LoadingTask = true;
      })
      .addCase(cancelTask.pending, (state) => {
        state.LoadingTask = true;
      })
      .addCase(resumeTask.rejected, (state) => {
        state.LoadingTask = false;
      })
      .addCase(holdTask.rejected, (state) => {
        state.LoadingTask = false;
      })
      .addCase(cancelTask.rejected, (state) => {
        state.LoadingTask = false;
      })
      .addCase(resumeTask.fulfilled, (state) => {
        state.LoadingTask = false;
      })
      .addCase(holdTask.fulfilled, (state) => {
        state.LoadingTask = false;
      })
      .addCase(cancelTask.fulfilled, (state) => {
        state.LoadingTask = false;
      });
  },
});

export const getUserTask = createAsyncThunk("TaskActions/GetUserTask", async (userTaskID: number) => {
  const userTasksService = container.get<IUserTasksService>(SERVICE_TYPES.UserTasksService);
  return await userTasksService.getUserTask(userTaskID);
});

export const resumeTask = createAsyncThunk("TaskActions/ResumeTask", async (userTaskID: number, thunkAPI) => {
  const userTasksService = container.get<IUserTasksService>(SERVICE_TYPES.UserTasksService);
  await userTasksService.resumeTask(userTaskID);
  thunkAPI.dispatch(getUserTask(userTaskID));
});

export const holdTask = createAsyncThunk("TaskActions/CompleteTask", async (userTaskID: number, thunkAPI) => {
  const userTasksService = container.get<IUserTasksService>(SERVICE_TYPES.UserTasksService);
  await userTasksService.holdTask(userTaskID);
  thunkAPI.dispatch(getUserTask(userTaskID));
});

export const cancelTask = createAsyncThunk("TaskActions/CancelTask", async (userTaskID: number, thunkAPI) => {
  const userTasksService = container.get<IUserTasksService>(SERVICE_TYPES.UserTasksService);
  await userTasksService.cancelUserTask(userTaskID);
  thunkAPI.dispatch(getUserTask(userTaskID));
});

export const selectUserTask = (state: RootState) => {
  return state.taskActions.UserTask;
};

export const selectLoadingTask = (state: RootState) => {
  return state.taskActions.LoadingTask;
};

export default taskActionsSlice.reducer;
